import { render, staticRenderFns } from "./ChildActivityConfigListPage.vue?vue&type=template&id=6b7fa466&scoped=true"
import script from "./ChildActivityConfigListPage.vue?vue&type=script&lang=js"
export * from "./ChildActivityConfigListPage.vue?vue&type=script&lang=js"
import style0 from "./ChildActivityConfigListPage.vue?vue&type=style&index=0&id=6b7fa466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7fa466",
  null
  
)

export default component.exports